import * as React from 'react';
import { Button } from '@grandvisionhq/common';
import { Modal } from '@grandvisionhq/lib-visuals';
import { useIntl } from '@grandvisionhq/state';
import StoreFilters from '../StoreFilters/StoreFilters.js';

const StoreFiltersModal = ({ isOpen , onModalClose , filters , appliedFilters , hasAppliedFilters , toggleFilter , resultsCount , isLoadingResults , clearFilters  })=>{
    const { getLabel , getFormattedLabel  } = useIntl();
    const labels = {
        cta: getLabel('stores.storeFilters.cta'),
        headerButton: getLabel('stores.storeFilters.modal.clearAll'),
        close: getLabel('stores.storeFilters.modal.close'),
        viewXResults: getFormattedLabel('stores.storeFilters.modal.viewXResults', {
            labelData: {
                count: `${resultsCount}`
            }
        })
    };
    const showResults = hasAppliedFilters && resultsCount > 0;
    const buttonCaption = showResults ? labels.viewXResults : labels.close;
    return /*#__PURE__*/ React.createElement(Modal, {
        isOpen: isOpen,
        onModalClose: onModalClose,
        onHeaderButtonClick: clearFilters,
        labels: labels,
        disableHeaderButton: !hasAppliedFilters,
        footer: /*#__PURE__*/ React.createElement(Button, {
            caption: buttonCaption,
            variant: showResults ? 'solid' : 'outline',
            className: "store-filters-modal__footer-button",
            onClick: onModalClose,
            isLoading: isLoadingResults
        })
    }, /*#__PURE__*/ React.createElement(StoreFilters, {
        filters: filters,
        appliedFilters: appliedFilters,
        toggleFilter: toggleFilter
    }));
};
var StoreFiltersModal$1 = StoreFiltersModal;

export { StoreFiltersModal$1 as default };
//# sourceMappingURL=StoreFiltersModal.js.map
